import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=05660946&scoped=true&"
import script from "./Contracts.vue?vue&type=script&lang=js&"
export * from "./Contracts.vue?vue&type=script&lang=js&"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=05660946&prod&lang=scss&scoped=true&"
import style1 from "./Contracts.vue?vue&type=style&index=1&id=05660946&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05660946",
  null
  
)

export default component.exports